var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8172 10.4423L12.1922 16.0673C12.0749 16.1846 11.9159 16.2505 11.75 16.2505C11.5841 16.2505 11.4251 16.1846 11.3078 16.0673C11.1905 15.95 11.1247 15.791 11.1247 15.6251C11.1247 15.4593 11.1905 15.3002 11.3078 15.1829L15.8664 10.6251H3.625C3.45924 10.6251 3.30027 10.5593 3.18306 10.442C3.06585 10.3248 3 10.1659 3 10.0001C3 9.83434 3.06585 9.67537 3.18306 9.55816C3.30027 9.44095 3.45924 9.3751 3.625 9.3751H15.8664L11.3078 4.81729C11.1905 4.70002 11.1247 4.54096 11.1247 4.3751C11.1247 4.20925 11.1905 4.05019 11.3078 3.93292C11.4251 3.81564 11.5841 3.74976 11.75 3.74976C11.9159 3.74976 12.0749 3.81564 12.1922 3.93292L17.8172 9.55792C17.8753 9.61596 17.9214 9.68489 17.9529 9.76077C17.9843 9.83664 18.0005 9.91797 18.0005 10.0001C18.0005 10.0822 17.9843 10.1636 17.9529 10.2394C17.9214 10.3153 17.8753 10.3842 17.8172 10.4423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.e97d6e0adb7e00b37469620c8f36f2fe.svg";
export { ForwardRef as ReactComponent };